<template>
  <main>
    <Transition name="fade">
      <div v-if="page">
        <PageHeader :content="page.data.header" />
        <!-- <SearchBar v-model="search" /> -->
        <FeedList :items="items as News[]" />
        <PageSections :sections="page.data.sections" />
      </div>
    </Transition>
  </main>
</template>

<script lang="ts">
import {SearchBar} from '@/components/blocks'
import {FeedList, PageHeader, PageSections} from '@/components/sections'
import {useNewsStore, usePageStore} from '@/stores'
import {ViewDataMixin} from '@/views/mixins'
import {useSearch} from '@/composables'
import { ref } from 'vue'

export default {
  name: 'NewsIndex',
  mixins: [ViewDataMixin],
  components: {FeedList, PageHeader, PageSections, SearchBar},
  setup() {
    const news = ref<News[]>([])
    const {search, items} = useSearch(news)
    return {search, items, news}
  },
  data() {
    return {
      page: null as Page | null,
    }
  },
  methods: {
    async init() {
      const [page, news] = await Promise.all([usePageStore().get('news'), useNewsStore().all()])

      if (!page) {
        return await this.$router.push({name: this.$routes.NOT_FOUND})
      }

      this.page = page
      this.news = news
    },
  },
}
</script>
